import React from 'react';
import './FeatureArticleHeader.scss';
import PropTypes from "prop-types";

import Header from "components/Header";

import featureArticleLogo from 'assets/feature-article-logo.svg';

class FeatureArticleHeader extends React.Component {
    static propTypes = {
        menu: PropTypes.object,
        urlToLandingPage: PropTypes.string,
        hideAfPosten:PropTypes.bool
    };

    state = {
        isLastScrollUp: false, 
        lastScrollChangePosition: 0,
        startAnimation: true,
    }

    handleNavigation = (e) => {
        const window = e.currentTarget;
        const isScrollUp = this.prev > window.scrollY;

        if (isScrollUp !== this.state.isLastScrollUp) {
            this.setState({lastScrollChangePosition: window.scrollY});
        }else {
            if (this.state.lastScrollChangePosition - window.scrollY > 50) {
                this.setState({startAnimation: true});
            }else if(this.state.lastScrollChangePosition - window.scrollY < -50) {
                this.setState({startAnimation: false});
            }
        }
        this.setState({isLastScrollUp: isScrollUp});
        
        this.prev = window.scrollY;
    };

    componentDidMount() {
        this.prev = window.scrollY;
        this.setState({lastScrollChangePosition: window.scrollY});
        window.addEventListener('scroll', e => this.handleNavigation(e));
    }

    render(){
        if(this.props.hideAfPosten) return <Header {...this.props.menu}/>;
        return (
            <div className="feature-article-header">
                <div className="feature-article-header__header" style={!this.state.startAnimation ? {marginTop: '-70px'} : null}><Header {...this.props.menu}/></div>
                <a className="feature-article-header__feature-header" href={this.props.urlToLandingPage}>
                    <div className="feature-article-header__feature-logo-wrapper">
                        <img className="feature-article-header__feature-logo" src={featureArticleLogo} alt="AF-Posten"></img>
                    </div>
                </a>
            </div>
        );}
}

export default FeatureArticleHeader;



// WEBPACK FOOTER //
// ./src/components/FeatureArticleHeader/FeatureArticleHeader.jsx